export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL!;
export const LLM_BASE_URL = process.env.NEXT_PUBLIC_LLM_BASE_URL!;

// export const API_BASE_URL = "https://mira-client-balancer.alts.dev";
// export const LLM_BASE_URL = "https://mira-client-balancer.alts.dev/v1";

// export const API_BASE_URL = "http://localhost:8000";
// export const LLM_BASE_URL = "http://localhost:8000/v1";
// export const LLM_BASE_URL = "http://localhost:34523/v1";
